import Loading from "components/common/Loading";
import { useHttpUtil } from "context/HttpContext";
import Stats from "libs/utils/stats";
import { useEffect, useState } from "react"
import CustomImage from "components/common/CustomImage";

type ShopifyProduct = {
    id : string,
    title: string,
    featureImage ?: string,
    images?: string[]
}

// Shopify 产品
export default function Shopify(props: { onImageClick: Function}){

    const [ parentProduct, setParentProduct ]= useState<ShopifyProduct|null>(null);
    const [ isAuthPull, setIsAuthPull ] = useState<boolean>(false);
    const [ list, setList] = useState<ShopifyProduct[]>();
    const [ isLoading, setIsLoading ]= useState<boolean>(false);
    const httpUtil = useHttpUtil();
    
    useEffect(() => {
        if(localStorage.getItem('AUTH-PULL')){
            setIsAuthPull(true);
        }
        
    },[])

    const pullList = () => {
        setIsAuthPull(true);
        localStorage.setItem('AUTH-PULL', "1");
        Stats.google('Fetch Shopify image');
    }

    useEffect(() => {
        if(isAuthPull) initList();
    }, [ isAuthPull ])

    const initList = async () => {
        setIsLoading(true);
        const plist = await httpUtil.post('/api/sync/shopify');
        const list : ShopifyProduct[] = [] ;
        plist.data?.map((pitem: any) => {
            const node = pitem.node ;
            const item: ShopifyProduct = {
                id :node.id,
                title: node.title
            } ;
            item.featureImage = node.featuredMedia && node.featuredMedia.preview.image.url ;
            const mediaList = node.media.edges ;
            let images : string[] = [];
            mediaList && mediaList.map((sitem:any) => {
                if(sitem.node.mediaContentType === 'IMAGE')
                    images.push(sitem.node.preview.image.url);
            })
            item.images = images ;
            list.push(item);
        })
        setList(list);
        setIsLoading(false);
    }

    const productClickHandler = async (product: ShopifyProduct) => {
        setParentProduct({...product})
    }

    const back = () => {
        setParentProduct(null)
    }

    return (
        <div className="absolute z-[10001] h-full top-[0px] shadow-lg bg-[#FFFFFF] xl:w-[320px] xl:left-[100px] w-[200px] left-[70px]">
            <div className="relative flex flex-col h-full w-full p-[10px] xl:p-[20px] overflow-y-auto z-[10001]  bg-[#FFFFFF]">
                <p className="medium-txt font-medium">Redesign your shopify product images</p>
                {
                    !isAuthPull ?
                        <div className="flex mt-[20px] w-full items-center justify-center rounded-[10px] bg-gradient-to-r from-[#14A5FA] to-[#10F28D] cursor-pointer text-[#FFFFFF] text-[14px] xl:py-[10px] gap-[10px] py-[6px]"
                            onClick={pullList}>
                            <span className="small-txt">One-Click Fetch</span>
                        </div>
                    : 
                    (!parentProduct ? 
                        (
                            !isLoading ?
                                (
                                    list && list.length ?
                                        <div className="grid grid-cols-2 gap-[5px] xl:gap-[10px] mt-[5px] xl:mt-[10px]">
                                            {
                                                list.map((product: ShopifyProduct) => (
                                                    <div className="cursor-pointer" key={product.id} onClick={() => productClickHandler(product)}>
                                                        <div className="rounded-[10px] aspect-square flex items-center justify-center border p-[3px]">
                                                            <CustomImage src={product.featureImage || "/no-image.png"} className="max-w-full max-h-full rounded-[3px]" />
                                                        </div>
                                                        <div className="flex items-center gap-[5px] mt-[5px]">
                                                            <CustomImage src="/icon/icon-shopify-dir.png" className="w-[15px]" />
                                                            <span className="font-semibold truncate">{product.title}</span>
                                                        </div>
                                                        <span className="ml-[20px] text-[#9C9C9C] text-[10px]">{product.images?.length || 0} images</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    :
                                        <div className="mt-[40%] text-center px-[1px] xl:px-[40px]">
                                            <CustomImage src="/icon/icon-shopify-empty.png" className="w-full"/>
                                            <span className="font-semibold medium-txt text-[#BFBFBF]">Your Shopify store currently has no products</span>
                                        </div>
                                )
                                    
                            :
                                <div className="mt-[80px] text-center">
                                    <Loading className="!pb-[5px]"/>
                                    <p>Synchronizing products, please wait...</p>
                                </div>
                        )
                    : 
                        <>
                            <div className="relative mt-[10px] py-[10px] pl-[40px] pr-[20px] text-center">
                                <CustomImage src="/icon/icon-left.png" className="absolute left-0 top-[11px] w-[20px] cursor-pointer" 
                                    onClick={back}/>
                                <span className="block truncate medium-txt">{parentProduct.title}</span>
                            </div>
                            <div className="grid xl:grid-cols-3 grid-cols-2 gap-[5px]">
                                {
                                    parentProduct.images?.map((img: string, index: number) => (
                                        <div className="rounded-[10px] aspect-square flex items-center justify-center border p-[3px]" key={index}>
                                            <CustomImage src={img} className="max-w-full max-h-full cursor-pointer rounded-[3px]" onClick={() => props.onImageClick(img)} />
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    )
}